<template>
  <tr :class="rowClass">
    <td class="cursor-pointer">
      <span class="bold">{{ businessRule.name }}</span>
    </td>
    <td class="hide-mobile">{{ truncate(businessRule.expression, 100) }}</td>
    <td>
      <action-button icon="fa-pen" @click="editClicked"></action-button>
      <action-button
        v-if="allowDelete"
        icon="fa-trash"
        @click="deleteClicked"
      ></action-button>
    </td>
  </tr>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import tableRow from "@/mixins/tableRow";
import { truncate } from "@/util/stringUtil";

const editClicked = function() {
  this.$router.push(`/businessrules/edit/${this.businessRule.id}`);
};

const deleteClicked = function() {
  this.$emit("delete", this.businessRule.id);
};

export default {
  mixins: [tableRow, documentModelMixin],
  props: ["businessRule"],
  computed: {
    allowDelete: function() {
      return (
        !!this.documentModel &&
        !this.documentModel.businessRuleInUse(this.businessRule.id)
      );
    },
  },
  methods: {
    truncate,
    editClicked,
    deleteClicked,
  },
  emits: ["delete"],
};
</script>
